import {db} from "@/firebase/init";
export default {
    computed:{
        all_accounts() {
            return this.$store.getters["hosting/accounts"];
        }
    },
    methods: {
        async assignDomain(domainName , supervisorID , collaboratorID, supervisor){
            //save in admin data
            const collaborator_data = await db.collection("users")
                .doc(supervisorID)
                .get()
                .then();
            let collaborators=[];
            console.log(collaborator_data.data().collaborators);
            collaborators = collaborator_data.data().collaborators;
            for(let collaborator of collaborators){
                if(collaborator.uid === collaboratorID){
                    collaborator.domains.push(domainName);
                    break;
                }
            }
            await db.collection('users').doc(supervisorID).update({
                collaborators: collaborators
            });
            //save in collaborator data
            const doc = await db.collection("users")
                .doc(collaboratorID)
                .get()
                .then();
            let supervisors = [];
            supervisors = doc.data()['supervisors'];
            for(let supervisor of supervisors){
                if(supervisor.supervisorId === supervisorID){
                    supervisor.allowedDomains.push(domainName);
                    break;
                }
            }
            await db.collection('users').doc(collaboratorID).update({
                supervisors: supervisors
            });
            supervisor.allowedDomains.push(domainName);
            await this.$store.dispatch("hosting/fetchAccounts", {UID: supervisorID, allowedDomains: supervisor.allowedDomains});
        },
        checkDuplication(domainName){
            for(let account of this.all_accounts){
                if(account.primary.domain === domainName){
                    return false
                }
                for(let addon of account.addon){
                    if(addon.domain === domainName){
                        return false
                    }
                }
            }
            return true
        }
    }
}
